export const LADE_AUSWAHLWERTE_JOURNAL = "ladeAuswahlwerteJournal";
